import {fetchWithAuth} from '../util/fetch';
import {EndpointURL} from '../constants';
import {push} from 'react-router-redux';
import {actionFactory} from '../util/redux-helpers';

export const ACTIONS = {
  LocationsLoading: 'LOCATIONS_LOADING',
  LocationsCompleted: 'LOCATIONS_LOADED',
  LocationsError: 'LOCATIONS_ERROR',

  LocationDetailsLoading: 'LOCATION_DETAILS_LOADING',
  LocationDetailsCompleted: 'LOCATION_DETAILS_LOADED',
  LocationDetailsError: 'LOCATION_DETAILS_ERROR',

  LocationTenderTypesLoading: 'LOCATION_TENDERTYPES_LOADING',
  LocationTenderTypesCompleted: 'LOCATION_TENDERTYPES_LOADED',
  LocationTenderTypesError: 'LOCATION_TENDERTYPES_ERROR',

  LocationUpdateTableInProgress: 'LOCATION_UPDATE_TABLE_INPROGRESS',
  LocationUpdateTableCompleted: 'LOCATION_UPDATE_TABLE_COMPLETED',
  LocationUpdateTableError: 'LOCATION_UPDATE_TABLE_ERROR',

  LocationPhotoUpdateInProgress: 'LOCATION_PHOTO_UPDATE_IN_PROGRESS',
  LocationPhotoUpdateCompleted: 'LOCATION_PHOTO_UPDATE_COMPLETED',
  LocationPhotoUpdateError: 'LOCATION_PHOTO_UPDATE_ERROR',

  LocationActivationInProgress: 'LOCATION_ACTIVATION_IN_PROGRESS',
  LocationActivationCompleted: 'LOCATION_ACTIVATION_COMPLETED',
  LocationActivationFailed: 'LOCATION_ACTIVATION_FAILED',

  LocationPropertyUpdateInProgress: 'LOCATION_PROP_UPDATE_INPROGRESS',
  LocationPropertyUpdateCompleted: 'LOCATION_PROP_UPDATE_COMPLETED',
  LocationPropertyUpdateError: 'LOCATION_PROP_UPDATE_ERROR',

  LocationAddInProgress: 'LOCATION_ADD_IN_PROGRESS',
  LocationAddCompleted: 'LOCATION_ADD_COMPLETED',
  LocationAddFailed: 'LOCATION_ADD_FAILED'
}

const LoadLocationsInProgress = actionFactory(ACTIONS.LocationsLoading);
const LoadLocationsCompleted = actionFactory(ACTIONS.LocationsCompleted);
const LoadLocationsError = actionFactory(ACTIONS.LocationsError);

const LoadLocationDetailsInProgress = actionFactory(ACTIONS.LocationDetailsLoading);
const LoadLocationDetailsCompleted = actionFactory(ACTIONS.LocationDetailsCompleted);
const LoadLocationDetailsError = actionFactory(ACTIONS.LocationDetailsError);

const LoadLocationTenderTypesInProgress = actionFactory(ACTIONS.LocationTenderTypesLoading);
const LoadLocationTenderTypesCompleted = actionFactory(ACTIONS.LocationTenderTypesCompleted);
const LoadLocationTenderTypesError = actionFactory(ACTIONS.LocationTenderTypesError);


const LocationTableUpdateInProgress = actionFactory(ACTIONS.LocationUpdateTableInProgress);
const LocationTableUpdateError = actionFactory(ACTIONS.LocationUpdateTableError);
const LocationTableUpdateCompleted = actionFactory(ACTIONS.LocationUpdateTableCompleted);

const LocationPhotoUpdateInProgress = actionFactory(ACTIONS.LocationPhotoUpdateInProgress);
const LocationPhotoUpdateError = actionFactory(ACTIONS.LocationPhotoUpdateError);
const LocationPhotoUpdateCompleted = actionFactory(ACTIONS.LocationPhotoUpdateCompleted);

const LocationActivationInProgress = actionFactory(ACTIONS.LocationActivationInProgress);
const LocationActivationCompleted = actionFactory(ACTIONS.LocationActivationCompleted);
const LocationActivationFailed = actionFactory(ACTIONS.LocationActivationFailed);

const LocationPropertyUpdateInProgress = actionFactory(ACTIONS.LocationPropertyUpdateInProgress);
const LocationPropertyUpdateCompleted = actionFactory(ACTIONS.LocationPropertyUpdateCompleted);
const LocationPropertyUpdateFailed = actionFactory(ACTIONS.LocationPropertyUpdateFailed);

const LocationAddInProgress = actionFactory(ACTIONS.LocationAddInProgress);
const LocationAddCompleted = actionFactory(ACTIONS.LocationAddCompleted);
const LocationAddFailed = actionFactory(ACTIONS.LocationAddFailed);

export function SyncLocationTables(locationId){
  return async function (dispatch) { //redux-thunk middleware for async dispatching support
    //dispatch(LoadLocationDetailsInProgress());
    try {
      let fetchResult = await fetchWithAuth(`${EndpointURL}admin/locations/${locationId}/sync`, {
        method: 'POST',
        body: "{}"
      });
      if (fetchResult.status === 200){
        let jsonBody = await fetchResult.json();
      } else {
        let textBody = fetchResult.text()
      }
    } catch (err) {
      console.log('ERROR syncing location');
    }
  }
}


export function LoadLocationsEpic(companyId) {
  return async function(dispatch) {
    dispatch(LoadLocationsInProgress());
    let fetchResult = null;
    try {
      if (companyId) {
        fetchResult = await fetchWithAuth(`${EndpointURL}admin/companies/${companyId}/locations`, {});
      } else {
        fetchResult = await fetchWithAuth(`${EndpointURL}admin/locations`, {});
      }
      if (fetchResult.status === 200){
        let jsonBody = await fetchResult.json();
        dispatch(LoadLocationsCompleted(jsonBody));
      } else {
        let textBody = fetchResult.text()
        dispatch(LoadLocationsError(textBody));
      }
    } catch (err) {
      dispatch(LoadLocationsError(err));
    }
  }
}

export function GetLocationTenderTypesEpic(locationId){
  return async function(dispatch) { //redux-thunk middleware for async dispatching support
    dispatch(LoadLocationTenderTypesInProgress());
    try {
      let fetchResult = await fetchWithAuth(`${EndpointURL}admin/locations/${locationId}/tenderTypes`, {});
      if (fetchResult.status === 200){
        let jsonBody = await fetchResult.json();
        dispatch(LoadLocationTenderTypesCompleted(jsonBody));
      } else {
        let textBody = fetchResult.text()
        dispatch(LoadLocationTenderTypesError(textBody));
      }
    } catch (err) {
      console.log('ERROR loading location');
      dispatch(LoadLocationTenderTypesError(err));
    }
  }
}

export function LoadLocationDetailsEpic(locationId) {
  return async function(dispatch) { //redux-thunk middleware for async dispatching support
    dispatch(LoadLocationDetailsInProgress());
    try {
      let fetchResult = await fetchWithAuth(`${EndpointURL}admin/locations/${locationId}`, {});
      if (fetchResult.status === 200){
        let jsonBody = await fetchResult.json();
        dispatch(LoadLocationDetailsCompleted(jsonBody));
      } else {
        let textBody = fetchResult.text()
        dispatch(LoadLocationDetailsError(textBody));
      }
    } catch (err) {
      console.log('ERROR loading location');
      dispatch(LoadLocationDetailsError(err));
    }
  }
}

export function UpdateLocationPhotoEpic(locationId, photoProperty, url, amsData) {
  return async function(dispatch) { //redux-thunk middleware for async dispatching support
    dispatch(LocationPhotoUpdateInProgress());
    let fetchResult = await fetchWithAuth(`${EndpointURL}admin/locations/${locationId}`, {
      method: 'PATCH',
      body: JSON.stringify([
        {op: 'add', path: `/${photoProperty}`, value: url},
        {op: 'add', path: `/${photoProperty}Ams`, value: amsData}
      ])
    });
    if (fetchResult.status === 200){
      await fetchResult.json();
      dispatch(LocationPhotoUpdateCompleted({location: locationId, photoProperty, url}));
    } else {
      let textBody = fetchResult.text()
      dispatch(LocationPhotoUpdateError(textBody));
    }
  }
}

export function UpdateLocationPropertyEpic(locationId, data) {
  return async function(dispatch) { //redux-thunk middleware for async dispatching support
    dispatch(LocationPropertyUpdateInProgress());
    
    const patchesToApply = Object.keys(data).reduce((patchData, key) => {
      patchData.push({op: 'add', path: `/${key}`, value: data[key]});
      return patchData;
    },[]);

    let fetchResult = await fetchWithAuth(`${EndpointURL}admin/locations/${locationId}`, {
      method: 'PATCH',
      body: JSON.stringify(patchesToApply)
    });
    if (fetchResult.status === 200){
      var r = await fetchResult.json();
      dispatch(LocationPropertyUpdateCompleted({location: locationId, data: r}));
    } else {
      let textBody = fetchResult.text()
      dispatch(LocationPropertyUpdateFailed(textBody));
    }
  }
}

export function UpdateLocationTable(locationId, tableId, beaconId, name){
  return async function(dispatch) { //redux-thunk middleware for async dispatching support
    dispatch(LocationTableUpdateInProgress());
    let fetchResult = await fetchWithAuth(
      `${EndpointURL}admin/locations/${locationId}/tables/${tableId}`,
       {
         method: 'PATCH',
         body: JSON.stringify({
           beaconId,
           name
         })
       });
    if (fetchResult.status === 200){
      console.log('Dispatching action: LocationTableUpdateCompleted');
      dispatch(LocationTableUpdateCompleted({location: locationId, _id: tableId, beaconId: beaconId}));
    } else {
      let textBody = fetchResult.text()
      dispatch(LocationTableUpdateError(textBody));
    }
  }
}


export function ActivateLocationEpic(locationId, omnivoreId) {
  return async (dispatch, getState) => {
    dispatch(LocationActivationInProgress());
    let fetchResult = await fetchWithAuth(`${EndpointURL}admin/locations/${locationId}`,{
      method: 'PATCH',
      body: {
        action: 'activate',
        omnivoreId
      }
    });
    if (fetchResult.status === 200){
      dispatch(LocationActivationCompleted(await fetchResult.json()));
    } else {
      dispatch(LocationActivationFailed(await fetchResult.text()));
    }
  }
}

export function AddLocationEpic(locationData) {
  console.log(locationData);
  return async (dispatch, getState) => {
    dispatch(LocationAddInProgress());
    let fetchResult = await fetchWithAuth(`${EndpointURL}admin/locations`,{
      method: 'POST',
      body: JSON.stringify(locationData)
    });
    if (fetchResult.status === 201) {
      let result = await fetchResult.json();
      dispatch(LocationAddCompleted(result));
      dispatch(push(`/location/${result._id}/details`));
    } else {
      dispatch(LocationAddFailed(await fetchResult.text()));
    }
  }
}



// WEBPACK FOOTER //
// ./src/actions/location.actions.js